<script lang="ts">
    import {onMount} from "svelte";
    import {MouseEnterTipsViewUtil} from "../Information/MouseEnterTipsViewUtil";

    export let label;
    export let type: 'success' | 'warning' | 'danger' = 'success';
    export let isBorder = false;

    export let hoverTipsMessage = '';

    $: className = (() => {
        const classNameArray = [];
        classNameArray.push('badge-view');
        classNameArray.push(type);
        if (isBorder) {
            classNameArray.push('border');
        }
        const className = classNameArray.join(' ');
        return className;
    })();

    onMount(() => {
    });

    function onMouseEnter(event) {
        if (hoverTipsMessage !== '') {
            MouseEnterTipsViewUtil.show(event, hoverTipsMessage);
        }
    }

</script>

<span class={className}
      on:mouseenter={onMouseEnter}
>
    { label }
</span>

<style lang="scss">
    .badge-view {
        padding-left: 0.5em;
        padding-right: 0.5em;
        padding-top: 0.25em;
        padding-bottom: 0.25em;
        border-radius: 0.25em;
        border-width: 1px;
        user-select: none;


        &.success {
            background-color: var(--success-color);
            color: var(--success-color-text);
        }

        &.warning {
            background-color: var(--warning-color);
            color: var(--warning-color-text);
        }


        &.danger {
            background-color: var(--danger-color);
            color: var(--danger-color-text);
        }

        &.border {
            background-color: var(--background-color);
            border-style: solid;
            border-color: var(--text-color);
            color: var(--text-color);

            &.success {
                border-color: var(--success-color);
                color: var(--success-color);
            }

            &.warning {
                border-color: var(--warning-color);
                color: var(--warning-color);
            }

            &.danger {
                border-color: var(--danger-color);
                color: var(--danger-color);
            }

        }

    }
</style>